/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-10-27 11:26:52
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-11 15:12:12
 */

export default [
	{
		path: '/login',
		component: () => import('@/views/user/login'),
		meta: { isSinglePage: true },
	},
	{
		path: '/register',
		component: () => import('@/views/user/register'),
		meta: { isSinglePage: true },
	},
	{
		path: '/bind',
		component: () => import('@/views/user/bind'),
		meta: { isSinglePage: true },
	},
	{
		path: '/invite',
		component: () => import('@/views/invitePassword'),
		meta: { isSinglePage: true },
	},
];
